// gimme: conversations-inbox-ui 06/04/2020 c274e8ac5510b62b817eb74db200bc9802a2508d
'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WARNING_MODAL_WIDTH = 500;
export default class HardDeleteThreadPrompt extends Component {
  render() {
    const {
      onConfirm,
      onReject,
      ticket
    } = this.props;
    let deleteHeader;
    let deleteText;
    if (ticket) {
      deleteHeader = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.ticket-deletion.deletePrompt.heading"
      });
      deleteText = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.ticket-deletion.deletePrompt.body"
      });
    } else {
      deleteHeader = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.thread-deletion.deletePrompt.heading"
      });
      deleteText = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.thread-deletion.deletePrompt.body"
      });
    }
    return /*#__PURE__*/_jsxs(Modal, {
      use: "danger",
      width: WARNING_MODAL_WIDTH,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onReject
        }), /*#__PURE__*/_jsx(H2, {
          children: deleteHeader
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: deleteText
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          use: "danger",
          onClick: onConfirm,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-thread-view.thread-deletion.deletePrompt.confirm"
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          onClick: onReject,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-thread-view.thread-deletion.deletePrompt.cancel"
          })
        })]
      })]
    });
  }
}
HardDeleteThreadPrompt.displayName = 'HardDeleteThreadPrompt';
HardDeleteThreadPrompt.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  ticket: PropTypes.object
};